<div class="row">
  <div class="col">
    <div class="form-group">
      <label>Event Name</label>
      <input type="text" class="form-control form-control-sm" [(ngModel)]="eventCopy.eventName" />
    </div>
  </div>
</div>
<div class="row">
  <div class="col">
    <div class="form-group">
      <app-form-group-datepicker label="Start date" [(model)]="currentStartDate" (modelChange)="onDateChange('startDate')">
      </app-form-group-datepicker>
    </div>
  </div>
  <div class="col">
    <div class="form-group">
      <app-form-group-datepicker label="End date" [(model)]="currentEndDate" (modelChange)="onDateChange('endDate')">
      </app-form-group-datepicker>
    </div>
  </div>
  <div class="col">
    <div class="form-group">
      <label>VALID TO</label>
      <div style="font-size:14px;padding-top:5px;">{{eventCopy.endDate}} 04:00</div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col">
    <div class="form-group">
      <app-form-group-datepicker label="Pickup date" [(model)]="eventCopy.pickUpDate">
      </app-form-group-datepicker>
    </div>
  </div>
  <div class="col">
    <div class="form-group">
      <app-form-group-datepicker label="Return date" [(model)]="eventCopy.returnDate">
      </app-form-group-datepicker>
    </div>
  </div>
</div>
<div class="row">
  <div class="col text-right">
    <button type="button" class="btn btn-danger btn-sm mr-2" (click)="onCancelButtonClick()">Cancel</button>
    <button type="button" class="btn btn-primary btn-sm" (click)="onUbdateButtonClick()">Update</button>
  </div>
</div>
